﻿window.info_tp2_ti = function () {
    var instance = {
        selectrow: function (_equalRows, _remainingRows) {         
            const equalRows = _equalRows.split(";").filter(item => item !== '');
            const remainingRows = _remainingRows.split(";").filter(item => item !== '');
            equalRows.forEach((rowId) => {
                const seldata = $('tr[data-rowid="' + rowId + '"]').attr('data-select');
                if (seldata == "true") {
                    let selrow = $('tr[data-rowid="' + rowId + '"]');
                    selrow.css('background-color', '');
                    selrow.attr('data-select', "false");
                }
                else {
                    let selfalse = $('tr[data-rowid="' + rowId + '"]');
                    selfalse.css('background-color', '#e3eeff');
                    selfalse.attr('data-select', "true");
                }
            });
            remainingRows.forEach((rowId) => {
                let selrow = $('tr[data-rowid="' + rowId + '"]');
                selrow.css('background-color', '');
                selrow.attr('data-select', "false");
            });

        }
    };
    return instance;
}();